/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';
import { CaseEngagementDoc } from '../../data/types';

export type CaseEngagementState = {
    engagementDoc?: CaseEngagementDoc;
    addendums?: CaseEngagementDoc[];
};

export const useCaseEngagementState = () => {
    const caseEngagementState = useSelector((state: RootState | any) => state.caseEngagement as CaseEngagementState);
    return caseEngagementState;
}

// Define the initial state using that type
const initialState: CaseEngagementState = {
    engagementDoc: undefined,
    addendums: [],
}

export const caseEngagementSlice = createSlice({
    name: 'caseEngagement',
    initialState: initialState,
    reducers: {
        setCaseEngagementAction: (state, action: PayloadAction<CaseEngagementDoc | undefined>) => {
            state.engagementDoc = action.payload;
        },
        setCaseEngagementAddendumsAction: (state, action: PayloadAction<CaseEngagementDoc[] | undefined>) => {
            state.addendums = action.payload;
        },
    }
})

export const { setCaseEngagementAction, setCaseEngagementAddendumsAction } = caseEngagementSlice.actions;

export default caseEngagementSlice.reducer;